<div class="device_typeModal" *ngIf="data.type != 'delete-oven-dialog'">
  <div class="modal-header">
    <h4 class="modal-title">{{jobTitle}} Job</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="jobform" (submit)="onSubmit()">
      <div class="form-row">
        <div class="form-group">
          <label for="JOB_NO" class="bold-label">Job ID {{data.type}}</label>
          @if (data.type!='editjob') {
            <input
            id="JOB_NO"
            type="text"
            formControlName="JOB_NO"
            placeholder="Enter Job Number"
          />
          }@else {
            <input
            id="JOB_NO"
            type="text"
            placeholder="Enter Job Number"
            [value]="jobform.getRawValue().JOB_NO"
            disabled
          />
          }
          <div *ngIf="jobform.get('JOB_NO')?.invalid && jobform.get('JOB_NO')?.touched" class="error-message">
            Job ID is required
          </div>
        </div>
        
        <div class="form-group">
          <label for="no_of_sensor" class="bold-label">No. of Sensors</label>
          @if(data.type!='editjob'){
            <input
            id="no_of_sensor"
            type="number"
            inputmode="numeric"
            min="1"
            max="3"
            formControlName="no_of_sensor"
            placeholder="Enter number of sensors"
            />
          }@else {
            <input
            id="no_of_sensor"
            type="number"
            inputmode="numeric"
            min="1"
            max="3"
            [value]="jobform.getRawValue().no_of_sensor"
            placeholder="Enter number of sensors"
            disabled
          />
          }
          <div *ngIf="jobform.get('no_of_sensor')?.invalid && jobform.get('no_of_sensor')?.touched" class="error-message">
            Number of sensors must be 1 or 3
          </div>
        </div>
        
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="start_date" class="bold-label">Start Date</label>
          @if (data.type!='editjob') {
            <input
            id="start_date"
            type="datetime-local"
            formControlName="start_date"
          />
          }@else {
            <input
            id="start_date"
            type="datetime-local"
            [value]="jobform.getRawValue().start_date | date:'yyyy-MM-ddTHH:mm'"
            disabled/>
          }
          <div *ngIf="jobform.get('start_date')?.invalid && jobform.get('start_date')?.touched" class="error-message">
            Start date is required
          </div>
        </div>
        
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="" class="bold-label">Meggar Value</label>
          <input
            id="megger_value"
            type="number"
            formControlName="megger_value"
            placeholder="Enter meggar value"
            [disabled]="meggerCheck"
          />
          <div *ngIf="jobform.get('megger_value')?.invalid && jobform.get('megger_value')?.touched" class="error-message">
            Meggar value is required
          </div>
        </div>
        
        <div class="form-group">
          <label for="PI_value" class="bold-label">PI Value</label>
          <input
            id="PI_value"
            type="text"
            formControlName="PI_value"
            placeholder="Enter PI value"
            [disabled]="meggerCheck"
          />
          <div *ngIf="jobform.get('PI_value')?.invalid && jobform.get('PI_value')?.touched" class="error-message">
            PI value is required
          </div>
        </div>
      </div>
      
      <!-- Dynamic Sensor Fields -->
      <div class="sensors-container" [@sensorListAnimation]="sensorControls.length">
        <h5 class="sensors-title">Sensor Details</h5>

        @if (data.type!='editjob') {
        <div class="sensor-field" *ngFor="let control of sensorControls; let i = index" [@sensorFieldAnimation]>
          <div class="form-row">
            <div class="form-group">
              <label for="sensor_serial_no_{{i+1}}">Sensor {{i + 1}} - Serial No.</label>
              <select [formControlName]="'sensor_serial_no_' + (i + 1)" class="custom-select" id="sensor_serial_no_{{i+1}}">
                <option *ngFor="let free_sensor of available_sensors" [value]="free_sensor.serial_number">
                  {{ free_sensor.serial_number }}
                </option>
              </select>

              <div *ngIf="jobform.get('sensor_serial_no_' + (i + 1))?.invalid && jobform.get('sensor_serial_no_' + (i + 1))?.touched" class="error-message">
                Sensor serial number is required
              </div>
            </div>
            
            <div class="form-group" *ngIf="i < sensorControls.length">
              <div class="sensor-divider"></div>
            </div>
          </div>
        </div>
        }@else {
          <div class="sensor-field" *ngFor="let control of sensorControls; let i = index" [@sensorFieldAnimation]>
          <div class="form-row">
            <div class="form-group">
              <label for="sensor_serial_no_{{i+1}}">Sensor {{i + 1}} - Value.</label>
              <input [value]="jobform.getRawValue()[('sensor_serial_no_' + (i + 1))]" disabled/>
            </div>
            
            <div class="form-group" *ngIf="i < sensorControls.length ">
              <label for="sensor_serial_no_{{i+1}}">Sensor {{i + 1}} - Value.</label>
              <input [value]="jobform.getRawValue()[('sensor_serial_no_' + (i + 1)+'_value')]" disabled/>
              
            </div>
          </div>
        </div>
        }

      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="supervisor_name" class="bold-label">Supervisor Name</label>
          <input
            id="supervisor_name"
            type="text"
            formControlName="supervisor_name"
            placeholder="Enter supervisor name"
          />
          <div *ngIf="jobform.get('supervisor_name')?.invalid && jobform.get('supervisor_name')?.touched" class="error-message">
            Supervisor name is required
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="comment_box" class="bold-label">Add Comment</label>
          <input
            id="comment"
            type="text"
            formControlName="comment"
            placeholder="Please enter your comment..."
          />
          <div *ngIf="jobform.get('comment_box')?.invalid && jobform.get('comment_box')?.touched" class="error-message">
            Supervisor name is required
          </div>
        </div>
      </div>

      <div class="dialog-actions">
        <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
          @if(data.type!=='editjob'){
            <button type="submit" class="save-btn" [disabled]="jobform.invalid  || !jobform.touched" [@saveButtonState]="jobform.valid ? 'valid' : 'invalid'">
              <span>Save</span>
              <i class="material-icons" *ngIf="jobform.valid && jobform.touched">check_circle</i>
            </button>
          }@else {
            <button type="submit" class="save-btn" [disabled]="!formChanged || jobform.invalid" [@saveButtonState]="formChanged ? 'valid' : 'invalid'"><span>Save</span></button>
          }
      </div>
    </form>
  </div>
</div>

<div *ngIf="data.type === 'delete-oven-dialog'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <img
        style="height: 40px; width: 40px"
        class="m_r_10"
        src="assets/warning.png"
        onerror="this.src='assets/warning.png'"
      />
      <p class="m_0">Are you sure you want to permanently remove?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      (click)="deleteJobData()"
    >
      Delete
    </button>
    <button type="button" class="btn default_btn" (click)="onCancel()">
      Cancel
    </button>
  </div>
</div>